import { useSelector } from 'react-redux';

const useDisplayedActionsForRoom = (path) => {
  const displayedActionsForRoom = useSelector(state => state.actions.displayedActionsForRoom[path]);

  return displayedActionsForRoom;
};

export default useDisplayedActionsForRoom;
